/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Previous_SessionsInputs */

const fr_no_previous_sessions = /** @type {(inputs: No_Previous_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune session précédente trouvée`)
};

/**

* @param {No_Previous_SessionsInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const no_previous_sessions = /** @type {((inputs?: No_Previous_SessionsInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Previous_SessionsInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_no_previous_sessions(inputs)
});